import { durationNormal } from "./armor-system-XFLPR42X.js";

// src/mixins/transition.ts
var transition = function transition(transitions) {
  return function () {
    return "transition: ".concat(Object.keys(transitions).map(function (property) {
      var transitionOption = transitions[property];
      var duration = "".concat(durationNormal, "ms");
      if (typeof transitionOption === "number") {
        duration = "".concat(transitionOption, "s");
      }
      return "".concat(property, " ").concat(duration, " ease");
    }).join(","), ";");
  };
};
export { transition };